export const sponsorsInitialState = {
    sponsors: [],
    isLoading: true,
    pagination: null,
}